export class VesselOwnershipTransfer {
    id?: string;
    vesselId: string;
    userName: string;
    userOid: string;
    ownershipStatus: VesselOwnershipStatus;
    version: string;
    comment?: string;
    messageRead: boolean;
    assignerOid?: string;
}

export enum VesselOwnershipStatus {
    Undefined = 'undefined',
    Assigned = 'assigned',
    Claimed = 'claimed',
    Rejected = 'rejected',
    Requested = 'requested',
    Left = 'left',
    Removed = 'removed',
}

export class OwnerChangePayload {
    shipyardId: string;
    vesselId: string;
    vesselName: string;
    vesselVersion: string;
    senderName?: string;
    senderEmail?: string;
    senderOid?: string;
    receiverName: string;
    receiverEmail: string;
    receiverOid: string;
    assignerOid?: string;
    comment?: string;
    ownershipStatus: VesselOwnershipStatus;
    skipGuard?: boolean = true;
}
